<template>
    <multiselect
        class="forum-multiselect"
        :options="options"
        :value="value"
        @input="$emit('input', $event)">
    </multiselect>
</template>

<script>
    // ForumMultiselect: stylizes the multiselect input for the forum.

    import Multiselect from '../multiselect';

    export default {
        // See src/components/reusable/multiselect/index.vue for prop details.
        props: ['options', 'value'],

        components: {
            Multiselect,
        },
    }
</script>

<style lang="scss">
    .forum-multiselect.multiselect {
        button {
            background-color: #1e1e1e;
            width: 100%;
            padding: 4px 10px;

            &.selected {
                background: #b0b0b0;
                color: #161616;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// multiselect.vue?52cec1fd